import React, { FC, ReactNode } from 'react'
import '../icon.scss'

export const IV24GermanyIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container iv24-icon-container' data-testid='iv24-germany-icon'>
      <img
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/e040e2cc8c0bced4eec708b1e0b11d0e_210526-CI_Immoverkauf24-ICONS-rz_de.svg'
        }
        alt={''}
      />
    </div>
  )
}
